import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash, FaEnvelope, FaLock } from "react-icons/fa";
import { GoogleLogin } from "@react-oauth/google";
import NavBar from "../NavBar";
import Footer from "../Footer";
import "../Styles/AuthPages.css";

import API_BASE_URL from "../../config";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await axios.post(
                `${API_BASE_URL}/api/auth/login`,
                { email, password },
                { withCredentials: true }
            );
            if (res && res.data) {
                alert(res.data.message || "Login successful");
                localStorage.setItem("isLoggedIn", "true");
                navigate("/profile");
            }
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.message || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleLogin = async (credentialResponse) => {
        const token = credentialResponse.credential;
        try {
            const res = await axios.post(
                `${API_BASE_URL}/api/auth/google`,
                { token },
                { withCredentials: true }
            );
            if (res.data.success) {
                alert("Google login successful");
                localStorage.setItem("isLoggedIn", "true");
                navigate("/profile");
            } else {
                alert("Google login failed");
            }
        } catch (err) {
            console.error(err);
            alert("Google login failed");
        }
    };

    return (
        <div className="auth-page-wrapper">
            <NavBar />
            <div className="auth-page-container">
                <div className="auth-page-card">
                    <div className="auth-page-header">
                        <h1>Welcome Back</h1>
                        <p>Login to access your account</p>
                    </div>

                    <form onSubmit={handleSubmit} className="auth-page-form">
                        <div className="auth-form-group">
                            <label><FaEnvelope /> Email Address</label>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoComplete="email"
                            />
                        </div>

                        <div className="auth-form-group">
                            <label><FaLock /> Password</label>
                            <div className="auth-password-wrapper">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoComplete="current-password"
                                />
                                <button
                                    type="button"
                                    className="auth-password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                    tabIndex="-1"
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                        </div>

                        <button type="submit" className="auth-page-submit" disabled={loading}>
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </form>

                    <div className="auth-page-divider">
                        <span>or</span>
                    </div>

                    <div className="google-login-container">
                        <GoogleLogin
                            onSuccess={handleGoogleLogin}
                            onError={() => alert("Google login failed")}
                            useOneTap={false}
                            theme="filled_blue"
                            size="large"
                        />
                    </div>

                    <div className="auth-page-footer">
                        <p>
                            Don't have an account?{" "}
                            <Link to="/signup" className="auth-page-link">
                                Sign Up
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
